import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material"
import Autocomplete from "@mui/material/Autocomplete"
import { useEffect, useState } from "react"
import {
  selectEnteredInvoiceInformation,
  updateInvoiceDetail,
} from "../../activeScreenSlice"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import { useDebounce } from "../../hooks/useDebounce"
import useShowError from "../../hooks/useShowError"
import { getRequesterSearch } from "../../service/Requester"

import {
  StyledErrorIcon,
  StyledIcon,
  StyledStatusIcon,
} from "../FormTextBox/FormTextbox.styles"

import {
  AutocompleteWrapper,
  StyledTextField,
  RequesterLookupWrapper,
} from "./RequesterLookup.styles"
import { RequesterRead } from "../../api/generated"

export default function RequesterLookup() {
  const showError = useShowError()
  const dispatch = useAppDispatch()
  const invoiceInputs = useAppSelector(selectEnteredInvoiceInformation)

  const [nameTextEntry, setNameTextEntry] = useState<string | undefined>()
  const debouncedNameTextEntry = useDebounce(nameTextEntry)

  const [searchEnabled, setSearchEnabled] = useState(false)

  const [isValid, setIsValid] = useState(false)

  const [searchResults, setSearchResults] = useState<
    RequesterRead[] | undefined
  >([
    {
      username: "",
      last_name: "",
      first_name: "",
      full_name: "",
      valid_from: "",
      valid_to: "",
      opco_id: undefined,
      id: undefined,
    },
  ])

  function handleUpdateStore(key: string, value?: any) {
    dispatch(updateInvoiceDetail({ key: key, value: value }))
  }

  useEffect(() => {
    if (
      debouncedNameTextEntry !== undefined &&
      debouncedNameTextEntry.length < 2
    ) {
      setSearchResults([])
    }
    if (!searchEnabled) return
    if (debouncedNameTextEntry && debouncedNameTextEntry.length >= 2) {
      getRequesterSearch(debouncedNameTextEntry, invoiceInputs.opcoSlug)
        .then((res) => {
          const requesters = res.map((requester) => {
            return requester
          })
          setSearchResults(requesters)
        })
        .catch((error) => {
          showError(
            "An error occurred while searching for requester name: " +
              error.message,
          )
        })
    } else {
      setSearchResults([])
    }
  }, [showError, debouncedNameTextEntry])

  function handleValueUpdate(value: string | null | undefined) {
    const match = searchResults.filter(
      (requester) => requester.full_name === value,
    )
    if (match.length > 0) {
      handleUpdateStore("nonPoRequester", match[0]?.full_name)
      setIsValid(true)
    } else {
      handleUpdateStore("nonPoRequester", "")
      setIsValid(false)
    }
  }

  useEffect(() => {
    if (
      invoiceInputs.nonPoRequester !== "" &&
      invoiceInputs.nonPoRequester !== undefined
    ) {
      setIsValid(true)
    }
  }, [invoiceInputs.nonPoRequester])

  return (
    <>
      <RequesterLookupWrapper>
        <Box sx={{ width: "100%", display: "flex", flexDirection: "column" }}>
          <AutocompleteWrapper>
            <Autocomplete
              value={invoiceInputs.nonPoRequester || ""}
              onChange={(event, newValue) => {
                handleValueUpdate(newValue)
              }}
              inputValue={nameTextEntry || ""}
              onInputChange={(event, newInputValue) => {
                if (event !== null) {
                  setSearchEnabled(true)
                } else {
                  setSearchEnabled(false)
                }
                setNameTextEntry(newInputValue)
              }}
              options={searchResults.map((res) => res.full_name)}
              renderInput={(params) => (
                <StyledTextField
                  {...params}
                  label="Non PO Requester Name"
                  placeholder="Search by name..."
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    ...params.InputProps,
                    style: {
                      paddingTop: "0px",
                      height: "36px",
                    },
                  }}
                />
              )}
              style={{ width: "100%", paddingRight: "12px" }}
            />

            <StyledIcon style={{ paddingRight: "8px" }}>
              {isValid ? <StyledStatusIcon /> : <StyledErrorIcon />}
            </StyledIcon>
          </AutocompleteWrapper>
        </Box>
      </RequesterLookupWrapper>
    </>
  )
}
